module.exports = __webpack_public_path__ + "img/3.39dba5f9.jpg";